import { useEffect, useState } from 'react';
import { get } from '@aiptyg/api-client';
import { Link } from 'react-router-dom';
import { button, input, Panel, Notice, Pager, useCan, useResource } from './ui';
import type { Page } from './service';
interface Submission { assignment_id: number; member_alias: string; status: string; }
export function AgencySubmissions({ taskId }: { taskId: number }) {
  const can = useCan('agent_evidence.view');
  const canAssignment = useCan('assignments.view');
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState('');
  useEffect(() => {
    setPage(1);
    setStatus('');
  }, [taskId]);
  const r = useResource(
    () =>
      can
        ? get<Page<Submission>>(
            `/v1/admin/agent-tasks/${taskId}/submissions?page=${page}&page_size=20&status=${status}`,
          )
        : Promise.resolve({ items: [], total: 0, page: 1, page_size: 20 }),
    [taskId, page, status, can],
  );
  if (!can) return null;
  return (
    <>
      <Panel title="会员提交记录">
        <Notice error={r.error} />
        <div className="flex gap-3">
          <select
            className={input}
            aria-label="会员提交状态"
            value={status}
            onChange={(e) => {
              setStatus(e.target.value);
              setPage(1);
            }}
          >
            <option value="">全部提交状态</option>
            {[
              ['assigned', '已领取'],
              ['submitted', '待审核'],
              ['approved', '已通过'],
              ['settled', '已结算'],
              ['rejected', '已驳回'],
              ['expired', '已过期'],
            ].map(([k, t]) => (
              <option key={k} value={k}>
                {t}
              </option>
            ))}
          </select>
          <button className={button} onClick={r.reload}>
            刷新
          </button>
        </div>
        <div className="overflow-auto">
          <table className="w-full min-w-[720px] text-sm text-left">
            <thead className="bg-gray-50">
              <tr>
                {['提交记录', '会员匿名编号', '状态', '操作'].map(
                  (t) => (
                    <th key={t} className="p-3">
                      {t}
                    </th>
                  ),
                )}
              </tr>
            </thead>
            <tbody>
              {r.data?.items.map((x) => (
                <tr key={x.assignment_id} className="border-b border-gray-100">
                  <td className="p-3">#{x.assignment_id}</td>
                  <td className="p-3">{x.member_alias}</td>
                  <td className="p-3">{({assigned: "已领取", submitted: "待审核", approved: "已通过", settled: "已结算", rejected: "已驳回", expired: "已过期", cancelled: "已取消"} as Record<string, string>)[x.status] || x.status}</td>
                  <td className="p-3 flex gap-3">
                    {canAssignment && (
                      <Link
                        className="text-primary"
                        to={`/assignments/${x.assignment_id}`}
                      >
                        会员审核详情
                      </Link>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {!r.data?.items.length && !r.loading && (
            <p className="py-6 text-center text-gray-400">暂无会员提交</p>
          )}
        </div>
        <Pager total={r.data?.total ?? 0} page={page} change={setPage} />
      </Panel>
    </>
  );
}
